/* eslint-disable */
import constants from '@/constants';
import { updateMarket, updateMarketContracts } from '@/utils/notifications';

const DEFAULT_TOP_POSITION = 0;
const DEFAULT_RESET_POSITION_TIMEOUT = 0;

export default {
  namespaced: true,
  state: {
    lastTopPosition: DEFAULT_TOP_POSITION,
    currentPopup: null,
    currentSmallPopup: null,
    tradePopupOptions: {},
    currentPopupOptions: {},
    formDataCache: null,
    remember: {},
  },
  mutations: {
    setCurrentPopup(state, popupName) {
      if (popupName) {
        state.lastTopPosition = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
      }
      state.currentPopup = popupName;
      state.currentPopupOptions = {};
    },
    setCurrentSmallPopup(state, popupName) {
      if (popupName) {
        state.lastTopPosition = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
      }
      state.currentSmallPopup = popupName;
    },
    setTradePopupOptions(state, options) {
      state.tradePopupOptions = options;
    },
    setCurrentPopupOptions(state, options) {
      state.currentPopupOptions = options;
    },
    cacheFormData(state, payload) {
      state.formDataCache = payload;
    },
    rememberPopup(state, { route, popup }) {
      state.remember = {
        route,
        popup,
      };
    },
    restorePopup(state, payload) {
      if (state.remember.route === payload) {
        state.currentPopup = state.remember.popup;
      }
      state.remember = {};
    },
    resetLastTopPosition(state) {
      state.lastTopPosition = DEFAULT_TOP_POSITION;
    },
    updateTradePopupOptionsMarketFromNotification(state, data) {
      if (state.tradePopupOptions && state.tradePopupOptions.market) {
        state.tradePopupOptions = {
          ...state.tradePopupOptions,
          market: updateMarket(state.tradePopupOptions.market, data),
        }
      }
    },
    updateTradePopupOptionsContractsFromNotification(state, data) {
      if (state.tradePopupOptions && state.tradePopupOptions.market) {
        state.tradePopupOptions = {
          ...state.tradePopupOptions,
          market: updateMarketContracts(state.tradePopupOptions.market, data),
        }
      }
    },
  },
  actions: {
    setCurrentPopupWithDelay({ commit }, { name, options = {} }) {
      commit('setCurrentPopup', null);
      setTimeout(() => {
        commit('setCurrentPopup', name);
        commit('setCurrentPopupOptions', options);
      }, 1000);
    },
    setTradePopup({ commit }, { name, options }) {
      commit('setCurrentPopup', name);
      commit('setTradePopupOptions', options);
    },
    setCurrentPopup({ commit, state }, popupName = null) {
      return new Promise((resolve) => {
        commit('setCurrentPopup', popupName);
        if (!popupName && state.lastTopPosition !== DEFAULT_TOP_POSITION) {
          resolve();
        } else {
          resolve();
        }
      });
    },
    setCurrentSmallPopup({ commit, state }, popupName = null) {
      commit('setCurrentSmallPopup', popupName);
    },
    setTradePopupOptions({ commit }, options) {
      commit('setTradePopupOptions', options);
    },
    setCurrentPopupOptions({ commit }, options) {
      commit('setCurrentPopupOptions', options);
    },
    setGenericPopup({ commit }, popup) {
      commit('setCurrentPopup', popup.name);
      commit('setCurrentPopupOptions', popup.options);
    },
    setGenericSmallPopup({ commit }, popup) {
      commit('setCurrentSmallPopup', popup.name);
      commit('setCurrentPopupOptions', popup.options);
    },
    setErrorPopup({ commit }, content = '') {
      commit('setCurrentSmallPopup', 'generic-small');
      commit('setCurrentPopupOptions', {
        title: 'Error',
        icon: 'error',
        iconTitle: 'Error!',
        content,
      });
    },
    setSuccessPopup({ commit }, content = 'Operation successful.') {
      commit('setCurrentSmallPopup', 'generic-small');
      commit('setCurrentPopupOptions', {
        title: 'Success',
        icon: 'success',
        iconTitle: 'Success!',
        content,
      });
    },
    setSuccessPopupWithTimeoutCallback({ commit }, { content = 'Operation successful.', callback = () => {} }) {
      let callBackApplied = false;
      const timeout = setTimeout(
        () => {
          callBackApplied = true;
          callback.apply(this);
        },
        constants.DEFAULT_SMALL_POPUP_TIMEOUT,
      );
      commit('setCurrentSmallPopup', 'generic-small');
      commit('setCurrentPopupOptions', {
        title: 'Success',
        icon: 'success',
        iconTitle: 'Success!',
        onClose: () => {
          if (!callBackApplied) {
            clearTimeout(timeout);
            callback.apply(this);
          }
        },
        content,
      });
    },
    cacheFormData({ commit }, payload) {
      commit('cacheFormData', payload);
    },
    rememberPopup({ commit, state }, route) {
      commit('rememberPopup', route);
    },
    restorePopup({ commit }, route) {
      commit('restorePopup', route);
    },
    updateTradePopupOptionsMarketFromNotification({ commit }, data) {
      commit('updateTradePopupOptionsMarketFromNotification', data);
    },
    updateTradePopupOptionsContractsFromNotification({ commit }, data) {
      commit('updateTradePopupOptionsContractsFromNotification', data);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/popup.js